/**
 * What: Schemas and input contracts for Shopify recommendation change lists.
 * Transport / data-flow: Shared by the pure recommendation derivation and every packet/UI consumer.
 *
 */
import * as z from 'zod';
import { productFieldActionSchema, productFieldBindingSchema, productFieldPreviewContextSchema, productFieldTargetSchema, } from './product-field-binding.js';
export const recommendationCardTypeSchema = z.enum(['apply', 'keep_current', 'inconclusive', 'advisory', 'stale']);
export const recommendationBeforeAfterPayloadSchema = z.object({
    before: z
        .union([z.string(), z.record(z.string(), z.union([z.string(), z.number()])), z.array(z.string())])
        .nullable(),
    after: z.union([z.string(), z.record(z.string(), z.union([z.string(), z.number()])), z.array(z.string())]),
});
export const recommendationCardSchema = z.object({
    cardId: z.string(),
    elementType: z.string(),
    elementLabel: z.string(),
    type: recommendationCardTypeSchema,
    originalType: recommendationCardTypeSchema.optional(),
    action: productFieldActionSchema,
    target: productFieldTargetSchema,
    productId: z.string().nullable().optional(),
    variantIds: z.array(z.string()).nullable().optional(),
    winningArmId: z.string().nullable().optional(),
    winningArmLabel: z.string().nullable().optional(),
    leadingArmId: z.string().nullable().optional(),
    leadingArmLabel: z.string().nullable().optional(),
    leadingArmImageUrl: z.string().nullable().optional(),
    leadingArmT2bPercent: z.string().nullable().optional(),
    baselineArmId: z.string().nullable().optional(),
    baselineArmLabel: z.string().nullable().optional(),
    proposedValue: z
        .union([z.string(), z.record(z.string(), z.union([z.string(), z.number()])), z.array(z.string())])
        .nullable()
        .optional(),
    beforeAfterPayload: recommendationBeforeAfterPayloadSchema.nullable().optional(),
    recommendedChangeText: z.string().nullable().optional(),
    manualLocationInstructions: z.string().nullable().optional(),
    resolutionRequirement: z.string().nullable().optional(),
    driftDetails: z.string().nullable().optional(),
    deltaT2bPp: z.number().nullable().optional(),
    evidenceLabel: z.string(),
    evidenceKey: z.enum(['below_viability_threshold']).optional(),
    explanation: z.string(),
    binding: productFieldBindingSchema.nullable().optional(),
});
export const recommendationChangeListSchema = z.object({
    studyId: z.string(),
    cards: z.array(recommendationCardSchema),
    generatedAt: z.string(),
    previewContext: productFieldPreviewContextSchema.nullable().optional(),
});
//# sourceMappingURL=recommendation-change-list-contract.js.map